import {defineComponent} from 'vue';
import {createMemoryHistory, createRouter, createWebHistory, RouteLocationNormalized, Router} from 'vue-router';

const emptyComponent = defineComponent({render: () => null});

export function createRouterForComponent(element: Element, baseUri?: string): Router {
    const router = createRouter({
        history: baseUri === undefined
            ? createMemoryHistory()
            : createWebHistory(baseUri),
        linkActiveClass: 'active',
        scrollBehavior: () => ({el: '#' + element.getAttribute('id')}),
        routes: [
            {path: '/:catchAll(.*)', component: emptyComponent},
        ],
    });

    if (baseUri === undefined) {
        router.replace('/');
    }

    router.beforeEach((to, from) => {
        if (!hasQueryParams(to) && hasQueryParams(from)) {
            return {
                ...to,
                query: from.query,
                name: to.name ?? undefined,
            };
        }
    });

    return router;
}

function hasQueryParams(route: RouteLocationNormalized) {
    return Object.keys(route.query).length > 0;
}
